import React from 'react';
import { firebaseApp } from '../firebase/firebase';
import { User } from 'firebase';
import { BikeForm } from './bike-form';
import { useParams } from 'react-router-dom';

export function NewBike({ user }: { user: User }) {
  const { rider } = useParams();
  return (
    <BikeForm
      bike={{ name: '', engine: '4-stroke', notes: '' }}
      onSave={async bike => {
        await firebaseApp
          .firestore()
          .collection(`users/${user.uid}/bikes`)
          .add({ ...bike, rider });
      }}
    />
  );
}
